import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const auditLogService = createApi({
  reducerPath: "auditLogService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["auditLog"],
  endpoints: (builder) => ({
    getAllAuditLogs: builder.mutation({
      query: (body) => ({
        url: userManagement.auditLogsController.getAll,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getAuditLogById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.auditLogsController.getById}/${body.id}`,
        method: "GET",
         headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    saveAuditLog: builder.mutation({
      query: (body) => ({
        url: userManagement.auditLogsController.save,
        method: "POST",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

    bulkSaveAuditLog: builder.mutation({
      query: (body) => ({
        url: userManagement.auditLogsController.bulkSave,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),
    updateAuditLog: builder.mutation({
      query: (body) => ({
        url: `${userManagement.auditLogsController.update}/${body.payload.id}`,
        method: "PUT",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    deleteAuditLog: builder.mutation({
      query: (body) => ({
        url: `${userManagement.auditLogsController.delete}/${body.id}`,
        method: "DELETE",
         headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    searchAuditLogs: builder.mutation({
      query: (body) => ({
        url: userManagement.auditLogsController.search,
        method: "POST",
        body: body.payload,
         headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),
    getAllAuditLogsWithPagination: builder.mutation({
      query: (body) => ({
        url: `${userManagement.auditLogsController.getAllWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
         headers: { Authorization: `Bearer ${body.token}`},
      }),
    }),

  }),
});

export const {
  useGetAllAuditLogsMutation,
  useGetAuditLogByIdMutation,
  useSaveAuditLogMutation,
  useUpdateAuditLogMutation,
  useDeleteAuditLogMutation,
  useSearchAuditLogsMutation,
  useBulkSaveAuditLogMutation,
  useGetAllAuditLogsWithPaginationMutation,
} = auditLogService;
